// Import model
import { PickListItem } from '../models/PickListItem';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CatalogItem } from '../models/CatalogItem';

// Import dependency serializers (for complex types)
import { CatalogItemSerializer } from './CatalogItemSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PickListItem - handles JSON serialization and deserialization with type validation
 */
export class PickListItemSerializer {
  /**
   * Deserializes a JSON string into a PickListItem instance
   */
  static deserialize(json: string): PickListItem {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PickListItem instance
   */
  static fromObject(obj: any): PickListItem {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PickListItem');
    }


    const instance: PickListItem = {
      createdBy: obj['createdBy'] as string | undefined,
      createdByName: obj['createdBy|Name'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
      itemIdName: obj['itemId|Name'] as string | undefined,
      pickListId: obj['pickListId'] as string | undefined,
      pickListIdName: obj['pickListId|Name'] as string | undefined,
      item: obj['item'] ? CatalogItemSerializer.fromObject(obj['item']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PickListItem instances
   */
  static deserializeArray(json: string): PickListItem[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PickListItem instance to a JSON string
   */
  static serialize(instance: PickListItem): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PickListItem instance to a plain object
   */
  static toObject(instance: PickListItem): any {
    return {
      'createdBy': instance.createdBy,
      'createdBy|Name': instance.createdByName,
      'isActive': instance.isActive,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'itemId': instance.itemId,
      'itemId|Name': instance.itemIdName,
      'pickListId': instance.pickListId,
      'pickListId|Name': instance.pickListIdName,
      'item': instance.item ? CatalogItemSerializer.toObject(instance.item) : undefined,
    };
  }

  /**
   * Serializes an array of PickListItem instances to a JSON string
   */
  static serializeArray(instances: PickListItem[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
